/**
 * Internal dependencies
 */
import { applyEdits } from 'state/utils';
import isEditedSalesTypeDirty from './is-edited-sales-type-dirty';
import getConnectionSalesType from './get-connection-sales-type';
import getEdits from './get-edits';

export default (state, id) => {

    id = !id ? "" : id;

    if (isEditedSalesTypeDirty(state, id || "")) {
        let connectionSalesTypes = getConnectionSalesType(state, id);
        let edits = getEdits(state, id);
        connectionSalesTypes = applyEdits(connectionSalesTypes, edits);
        return connectionSalesTypes;
    }

    return getConnectionSalesType(state, id);
};